<template>
<div>
  <card class="week-field-group">
    <div class="row">
      <div class="col-9">
        <h5 class="card-title">Week {{weekNumber}}</h5>
      </div>
      <div class="col-3 text-right">
        <base-button
          size="sm"
          type="danger"
          icon="ni ni-fat-remove"
          @click="modalOpen = true"
        >
          Remove
        </base-button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <base-input
          label="Start Date"
          alternative=""
        >
          <flat-picker
            slot-scope="{focus, blur}"
            @on-open="focus"
            @on-close="blur"
            :config="{
              allowInput: true,
              dateFormat: 'Z',
              altInput: true,
              altFormat: 'D. M. j',
            }"
            class="form-control form-control-alternative datepicker"
            v-model="model.startDate"
            placeholder="YYYY-MM-DD"
          />
        </base-input>
      </div>
      <div class="col-lg-6">
        <base-input
          label="Course"
        >
          <Multiselect
            v-model="model.course"
            :options="courses"
            class="shadow"
            track-by="id"
            label="Name"
          />
        </base-input>
      </div>
    </div>
    <div class="row" v-if="isTeam">
      <div class="col-lg-3">
        <label class="form-control-label">
          Playoff (Group Stage)
        </label><br />
        <base-switch v-model="model.groupPlayoff"></base-switch>
      </div>
      <div class="col-lg-3">
        <label class="form-control-label">
          Playoff (Moving Week)
        </label><br />
        <base-switch v-model="model.movingWeek"></base-switch>
      </div>
      <div class="col-lg-3">
        <label class="form-control-label">
          Playoff (Live)
        </label><br />
        <base-switch v-model="model.livePlayoff"></base-switch>
      </div>
    </div>
    <div class="row" v-if="isFlex">
      <div class="col-lg-6">
        <base-input
          alternative=""
          label="Score Multiplier"
          input-classes="form-control-alternative"
          v-model="model.scoreMultiplier"
          type="number"
        />
      </div>
    </div>
  </card>
  <modal
    :show.sync="modalOpen"
    gradient="danger"
    modal-classes="modal-danger modal-dialog-centered"
  >
    <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

    <div class="py-3 text-center">
      <i class="fa fa-trash fa-3x"></i>
      <h4 class="heading mt-4">This can't be undone</h4>
      <p>Are you sure you want to remove this?  This action can't be undone.</p>
    </div>

    <template slot="footer">
      <base-button
        type="white"
        @click="removeWeek"
      >
        Delete
      </base-button>
      <base-button
        type="link"
        text-color="white"
        class="ml-auto"
        @click="modalOpen = false"
      >
        Cancel
      </base-button>
    </template>
  </modal>
</div>
</template>
<script>
import flatPicker from 'vue-flatpickr-component';
import Multiselect from 'vue-multiselect';
import 'flatpickr/dist/flatpickr.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'WeekFieldGroup',
  components: {
    flatPicker,
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    weekNumber: {
      type: Number,
    },
    courses: {
      type: Array,
    },
    isTeam: {
      type: Boolean,
      default: false,
    },
    isFlex: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalOpen: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    removeWeek() {
      this.modalOpen = false;
      this.$nextTick(() => {
        this.$emit('delete');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .week-field-group {
    margin-bottom: 1rem;

    &:last-child{
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .multiselect{
    min-height: 43px;
    box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
    border: 0 !important;
    border-radius: 0.375rem;

    .multiselect__tags{
      min-height: 43px;
      padding-top: 12px;
      border: 0;
      color:#8898aa;
    }

    .multiselect__select{
      padding-top: 13px;
    }
  }
</style>
